import { useQueryClient } from "@tanstack/react-query";
import { FinancialProposal } from "../../types";
import { extendProposal } from "../../api/rental-financial-proposal";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useExtendProposal() {
  const queryClient = useQueryClient();

  const mutation = useDomainMutation<
    AxiosResponse<FinancialProposal>,
    { response?: { data?: { message?: string } } },
    { uid: string }
  >({
    mutationFn: ({ uid }: { uid: string }) => {
      return extendProposal(uid);
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["financial-proposals"] });
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutation;
}
